<div class="d-flex flex-row justify-content-between align-items-center py-4 px-1 sidebar-options">
  <div class="navigate-button d-flex flex-column" *ngIf="config.navigateBackButton">
    <ui-fh-button
      [iconPos]="'left'"
      [severity]="'secondary'"
      [icon]="'fa-light fa-left'"
      (clickEvent)="onClickNavigateBack()"
      [label]="config.parentLabel | translate"></ui-fh-button>
  </div>
  <div class="button-close d-flex flex-column">
    <ui-fh-button
      [icon]="'fa-light fa-circle-xmark'"
      [pTooltip]="'generics.close' | translate"
      [severity]="'secondary'"
      (clickEvent)="onClickCloseButton()"></ui-fh-button>
  </div>
</div>
